import { MDBAnimation, MDBBadge, MDBCard, MDBCardBody, MDBCardImage, MDBCardText, MDBCol, MDBContainer, MDBIcon, MDBPagination, MDBPaginationItem, MDBPaginationLink, MDBRipple, MDBRow } from "mdb-react-ui-kit"
import { useEffect, useState, createContext, useContext } from "react"
import { Link, Outlet } from 'react-router'

import { GalleryContext } from '../../Gallery/Gallery'

export const GalleryContent = () => {

    const newContext = useContext(GalleryContext)

    const news = newContext?.news

    const newsList = newContext?.newsList

    // const pageHandler = () => newContext?.pageHandler()

    const index = newContext?.index

    const pager = newContext?.pager

    const pagerList = newContext?.pagerList

    const pagerIndex = newContext?.pagerIndex

    if (news === undefined) {
        return null
    }

    if (newsList === undefined) {
        return null
    }

    if (index === undefined) {
        return null
    }

    if (pager === undefined) {
        return null
    }

    if (pagerList === undefined) {
        return null
    }

    if (pagerIndex === undefined) {
        return null
    }


    return (
        <>
            <MDBContainer style={{ backgroundColor: '#1B5E20' }} className={'border border-0 border-danger bg-gradient'}>
                <MDBContainer className={'border border-0 border-danger d-flex align-items-center mt-5 text-white h1'}>
                    GALLERY
                </MDBContainer>
                <MDBContainer className={'border border-0 border-danger d-flex align-items-center mt-0 text-white h6'}>
                    <p>Let shares memories</p>
                </MDBContainer>
                <MDBContainer className={'border border-0 border-success py-5'}>
                    <MDBRow className={'border border-0 border-warning g-4 mb-3'}>

                        {newsList?.map(
                            (val, index) => (
                                <MDBCol key={index} sm={12} md={4}>

                                    <Link to={`gallery_detail/${index}`}>
                                        <MDBAnimation reset={true} animation={'pulse'} start={'onHover'}>
                                            <MDBCard className={'border border-0 border-danger'}>
                                                {/* <MDBRipple rippleColor='light' rippleTag='div' className='bg-image hover-overlay'> */}
                                                {/* <MDBCardImage className={'border border-0 border-danger w-100'} style={{ height: '200px' }} src={val.imgs[0]} fluid alt='...' /> */}
                                                <div className='border border-0 border-success bg-image'>
                                                    <img style={{height:'250px'}} src={val.imgs[0]} className='img-fluid' alt='Sample' />
                                                    <div className='border border-0 border-danger mask' style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)' }}>
                                                        <div className='border border-0 border-danger d-flex justify-content-start align-items-top h-100'>
                                                            <p className='text-white mb-0 mt-3 ms-3'>
                                                                <a href='#!'>
                                                                    <MDBIcon far icon="images" color="white" />
                                                                    <MDBBadge color='warning' notification pill>
                                                                        {val.imgs.length}
                                                                    </MDBBadge>
                                                                </a>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <a>
                                                    <div className='border border-0 border-danger rounded mask' style={{ backgroundColor: 'rgba(251, 251, 251, 0.15)' }}></div>
                                                </a>
                                                {/* </MDBRipple> */}
                                                <MDBCardBody>
                                                    <MDBCardText className={'border border-0 border-danger'}>
                                                        <div className={'text-truncate text-muted'} >
                                                        {val.heading}
                                                        </div>
                                                        <small className='text-muted'>
                                                            {/* <MDBIcon far icon="calendar-alt" />{val.date} */}
                                                        </small>
                                                    </MDBCardText>
                                                </MDBCardBody>
                                            </MDBCard>
                                        </MDBAnimation>
                                    </Link>
                                </MDBCol>
                            )
                        )}
                    </MDBRow>
                    {
                        news.length > 1 ? (

                            <MDBRow className={'border border-0 border-danger d-flex align-items-center'}>
                                <nav className={'border border-0 border-warning'} aria-label='...'>
                                    <MDBPagination end className='mb-0'>
                                        {
                                            pagerIndex > 0 ? (
                                                <MDBPaginationItem>
                                                    <MDBPaginationLink onClick={() => newContext?.pageBack()} href="#!" className={'text-warning'} tabIndex={-1} aria-disabled='true'>
                                                        <i className={"fas fa-angles-left"}></i>
                                                    </MDBPaginationLink>
                                                </MDBPaginationItem>
                                            )
                                                : ''
                                        }

                                        {

                                            pagerList.map(
                                                (val, i) => (


                                                    <MDBPaginationItem key={i} className={'border border-0 border-danger'}>
                                                        <MDBPaginationLink onClick={() => newContext?.pageHandler(val - 1)} href="#!" style={{ cursor: 'pointer' }} className={'text-warning border border-0 border-danger'} >{val}</MDBPaginationLink>
                                                    </MDBPaginationItem>


                                                )
                                            )

                                        }

                                        {
                                            pagerIndex === (pager.length - 1) ?
                                                '' :
                                                (
                                                    <MDBPaginationItem>
                                                        <MDBPaginationLink onClick={() => newContext?.pageForward()} className={'text-warning'} href='#!'>
                                                            <i className={"fas fa-angles-right"}></i>
                                                        </MDBPaginationLink>
                                                    </MDBPaginationItem>
                                                )
                                        }

                                    </MDBPagination>
                                </nav>
                            </MDBRow>
                        ) : ''
                    }
                </MDBContainer>
            </MDBContainer>
        </>
    )
}